import {useRef} from 'react';
import Konva from 'konva';

export function useAnnotatorRefs() {
  const layerRef = useRef<Konva.Layer>(null);
  const stageRef = useRef<Konva.Stage>(null);
  const imageLayerRef = useRef<Konva.Layer>(null);
  const transformerRef = useRef<Konva.Transformer>(null);

  return {
    layerRef,
    stageRef,
    imageLayerRef,
    transformerRef,
  };
}
